import "@/app/styles/global.css";
import React from "react";
import ReactDOM from "react-dom/client";

import App from "@/app";
import { URL_PATHS } from "@/shared/constants/url-path";
import { initSentry } from "@/shared/utils/sentryConfig";

if (
  typeof window !== "undefined" &&
  typeof navigator !== "undefined" &&
  !navigator.onLine &&
  window.location.pathname !== URL_PATHS.ROOT
) {
  window.history.replaceState(null, "", URL_PATHS.ROOT);
}

initSentry();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
